import { Component } from '@angular/core';
import { ToastService } from '../../../../services/toast.service';
import { Producao } from '../../../../types/producao.type';
import { ProducaoindustrialService } from '../../../../services/producaoindustrial.service';
import { TableLazyLoadEvent } from 'primeng/table';
import { SortMeta } from 'primeng/api';

// Mapeia o nome do campo usado na tabela (front) para o nome aceito pelo backend no parâmetro `sort`.
const MAPA_CAMPO_ORDENACAO: Record<string, string> = {
  cdEmpresaErp: 'empCodemp',
};

@Component({
  selector: 'app-producaos',
  templateUrl: './producaos.component.html',
  styleUrl: './producaos.component.css'
})
export class ProducaosComponent {

  producaos: Producao[] = [];
  loading: boolean = true;
  totalRecords: number = 0;
  rows: number = 20;
  filtro: string = '';

  private ultimoEvento: TableLazyLoadEvent = { first: 0, rows: this.rows };
  private debounceFiltro: any;

  constructor(private producaoIndustrialService: ProducaoindustrialService, private toastService: ToastService) { }

  carregar(event: TableLazyLoadEvent) {
    this.ultimoEvento = event;
    this.loading = true;

    const first = event.first ?? 0;
    const rows = event.rows ?? this.rows;
    const page = first / rows;
    const sort = this.montarParametrosOrdenacao(event);

    this.producaoIndustrialService.getProducaos(page, rows, this.filtro || undefined, sort).subscribe({
      next: (data) => {
        this.producaos = data.content;
        this.totalRecords = data.totalElements;
      },
      error: (error) => {
        this.toastService.erro("Erro", "Erro ao buscar: " + error.error);
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

  buscar() {
    clearTimeout(this.debounceFiltro);
    this.debounceFiltro = setTimeout(() => {
      this.carregar({ ...this.ultimoEvento, first: 0 });
    }, 400);
  }

  getProducaos() {
    this.carregar(this.ultimoEvento);
  }

  // Traduz o(s) critério(s) de ordenação da p-table (modo single ou multiple)
  // para o formato "campo,direcao" aceito repetidamente pelo parâmetro `sort` do backend.
  private montarParametrosOrdenacao(event: TableLazyLoadEvent): string[] {
    const criterios: SortMeta[] = event.multiSortMeta?.length
      ? event.multiSortMeta
      : (event.sortField && typeof event.sortField === 'string'
          ? [{ field: event.sortField, order: event.sortOrder ?? 1 }]
          : []);

    return criterios.map(criterio => {
      const campo = MAPA_CAMPO_ORDENACAO[criterio.field] ?? criterio.field;
      const direcao = criterio.order === -1 ? 'desc' : 'asc';
      return `${campo},${direcao}`;
    });
  }
}
